<template>
  <div v-if="visible" class="dialog-overlay">
    <div class="change">
      <div class="title">
        <!-- <span
          v-for="(title, index) in titles"
          :key="index"
          :class="{ active: activeTitleIndex === index }"
          @click="switchTitle(index)"
        >{{ title }}</span>-->
        <span :class="{ active: activeTitleIndex === 0 }">{{ title }}</span>
        <i class="el-icon-close close-icon" @click="close"></i>
      </div>
      <div class="content">
        <div
          v-for="(item, index) in contentItems"
          :key="index"
          class="item"
          :class="{ select: activeTitleIndex === index }"
        >
          <div v-if="index === 0">
            <!-- 根据 currentView 显示不同内容 -->
            <div v-show="currentView === 'login'" class="login-container">
              <!-- 登录表单 -->
              <div class="input-group1">
                <input
                  type="tel"
                  class="phone-input"
                  placeholder="请输入用户名或手机号"
                  v-model="phone"
                />
                <div class="error-message" id="phone-error">
                  {{ phoneError }}
                </div>
              </div>
              <!-- 验证码输入框 -->
              <div
                class="input-group code-input-group input-group1"
                id="password-group"
                :style="{ display: isCodeLogin ? 'flex' : 'none' }"
              >
                <input
                  type="text"
                  id="code-input"
                  placeholder="请输入验证码"
                  v-model="code"
                />
                <button
                  id="get-login-code-btn"
                  :disabled="isLoginCountingDown"
                  @click="getLoginCode"
                >
                  {{ getLoginCodeBtnText }}
                </button>
              </div>
              <!-- 密码输入框 -->
              <div
                class="input-group code-input-group input-group1"
                id="code-group"
                :style="{ display: isCodeLogin ? 'none' : 'flex' }"
              >
                <input
                  type="password"
                  class="password-input"
                  placeholder="请输入密码"
                  v-model="password"
                />
                <div class="error-message" id="code-error">{{ codeError }}</div>
              </div>
              <button id="login-btn" @click="login">登录</button>
              <div class="switch-login">
                <a id="forget-password" @click="switchToForgetPassword"
                  >忘记密码？</a
                >
              </div>
              <div class="register_link_max">
                <p>
                  还没有账号？
                  <a id="register-link" @click="switchToRegister">免费注册</a>
                </p>
              </div>
            </div>

            <div v-show="currentView === 'register'" class="register-container">
              <!-- 注册表单 -->
              <div class="input-group1">
                <input
                  type="text"
                  class="confirm-password-input"
                  placeholder="请输入用户名"
                  v-model="enroll_username"
                />
                <div
                  class="error-message"
                  id="username-error"
                  v-if="enroll_usernameError"
                >
                  {{ enroll_usernameError }}
                </div>
              </div>
              <div class="input-group1">
                <input
                  type="tel"
                  class="phone-input"
                  placeholder="请输入手机号"
                  v-model="enroll_phone"
                />
                <div
                  class="error-message"
                  id="phone-error"
                  v-if="enroll_phoneError"
                >
                  {{ enroll_phoneError }}
                </div>
              </div>
              <div class="input-group1 code-input-group">
                <input
                  type="text"
                  id="code-input"
                  placeholder="请输入验证码"
                  v-model="enroll_code"
                />
                <button
                  id="phone-code-btn"
                  :disabled="phoneIsCountdown"
                  @click="phoneCountdown"
                >
                  {{ phoneCodeBtnText }}
                </button>
                <div
                  class="error-message"
                  id="code-error"
                  v-if="enroll_codeError"
                >
                  {{ enroll_codeError }}
                </div>
              </div>
              <div class="input-group1">
                <input
                  type="password"
                  class="password-input"
                  placeholder="请输入密码"
                  v-model="enroll_password"
                />
                <div
                  class="error-message"
                  id="password-error"
                  v-if="enroll_passwordError"
                >
                  {{ enroll_passwordError }}
                </div>
              </div>
              <div class="input-group1">
                <input
                  type="password"
                  class="confirm-password-input"
                  placeholder="请确认密码"
                  v-model="enroll_confirmPassword"
                />
                <div
                  class="error-message"
                  id="confirm-password-error"
                  v-if="enroll_confirmPasswordError"
                >
                  {{ enroll_confirmPasswordError }}
                </div>
              </div>
              <!-- <div class="input-group1">
                <input
                  type="text"
                  id="confirm-password-input"
                  placeholder="请输入姓名"
                  v-model="enroll_nickname"
                />
                <div
                  class="error-message"
                  id="nickname-error"
                  v-if="enroll_nicknameError"
                >{{ enroll_nicknameError }}</div>
              </div> -->

              <!-- <div class="input-group1">
              <input
                type="text"
                id="confirm-password-input"
                placeholder="请输入电子邮件"
                v-model="enroll_email"
              />
              <div
                class="error-message"
                id="email-error"
                v-if="enroll_emailError"
              >{{ enroll_emailError }}</div>
            </div>
            <div class="input-group1">
              <el-select
                v-model="value"
                placeholder="请选择证件类型"
                class="el-select1"
                @change="handleChange"
              >
                <el-option
                  class="el-option1"
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
              <div
                  class="error-message"
                  id="idType-error"
                  v-if="enroll_idTypeError"
                >{{ enroll_idTypeError }}</div>
            </div>
            <div class="input-group1">
              <input
                type="text"
                id="confirm-password-input"
                placeholder="请输入证件号"
                v-model="enroll_idNumber"
              />
              <div
                class="error-message"
                id="idNumber-error"
                v-if="enroll_idNumberError"
              >{{ enroll_idNumberError }}</div>
            </div>
            <div class="input-group1">
              <el-select
                v-model="value1"
                placeholder="请选择性别"
                class="el-select1"
                @change="handleChange1"
              >
                <el-option
                  class="el-option1"
                  v-for="item in gender"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
               
              </el-select>
              <div
                  class="error-message"
                  id="gender-error"
                  v-if="enroll_genderError"
                >{{ enroll_genderError }}</div>
              </div>-->
              <button id="register-btn" @click="register">注册</button>
              <div class="register_link_max">
                <p>
                  已有账号？
                  <a
                    @click="switchToLogin"
                    style="color: #1e90ff; cursor: pointer"
                    >立即登录</a
                  >
                </p>
              </div>
            </div>

            <div
              v-show="currentView === 'forgetPassword'"
              class="forget-password-container"
            >
              <!-- 忘记密码表单 -->
              <div class="login-container">
                <div class="input-group1">
                  <input
                    type="tel"
                    class="phone-input"
                    placeholder="请输入手机号"
                    v-model="forget_phone"
                  />
                  <div
                    class="error-message"
                    id="phone-error"
                    v-if="forget_phoneError"
                  >
                    {{ forget_phoneError }}
                  </div>
                </div>
                <div class="input-group1 code-input-group">
                  <input
                    type="text"
                    id="code-input"
                    placeholder="请输入验证码"
                    v-model="forget_code"
                  />
                  <button
                    id="get-forget-code-btn"
                    :disabled="isForgetCountingDown"
                    @click="getForgetPasswordCode"
                  >
                    {{ getForgetCodeBtnText }}
                  </button>
                  <div
                    class="error-message"
                    id="code-error"
                    v-if="forget_codeError"
                  >
                    {{ forget_codeError }}
                  </div>
                </div>
                <div class="input-group1">
                  <input
                    type="password"
                    class="password-input"
                    placeholder="请输入新密码"
                    v-model="forget_password"
                  />
                  <div
                    class="error-message"
                    id="password-error"
                    v-if="forget_passwordError"
                  >
                    {{ forget_passwordError }}
                  </div>
                </div>
                <div class="input-group1">
                  <input
                    type="password"
                    class="confirm-password-input"
                    placeholder="请确认新密码"
                    v-model="forget_confirmPassword"
                  />
                  <div
                    class="error-message"
                    id="confirm-password-error"
                    v-if="forget_confirmPasswordError"
                  >
                    {{ forget_confirmPasswordError }}
                  </div>
                </div>
                <button id="register-btn" @click="submitForgetPassword">
                  确认
                </button>
                <div class="register_link_max">
                  <p>
                    已有账号？
                    <!-- 修改点击事件为 switchToLogin -->
                    <a
                      id="back-to-login"
                      style="color: #1e90ff; cursor: pointer"
                      @click="switchToLogin"
                      >返回登录</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-else id="wechat_qrcode"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import method from "@/utils/Untitl.js";
import { Message } from "element-ui";
import { mapState } from "vuex";

export default {
  name: "DialogComponent",
  props: {
    visible: {
      default: false,
    },
    title: {
      default: "弹窗标题",
    },
    currentView: {
      default: "login",
    },
  },
  computed: {
    ...mapState(["nuser_in"]),
    // 登录获取验证码按钮文本
    getLoginCodeBtnText() {
      if (this.isLoginCountingDown) {
        return `${this.loginCountdown}s 后重试`;
      }
      return "获取验证码";
    },
    // 忘记密码获取验证码按钮文本
    getForgetCodeBtnText() {
      if (this.isForgetCountingDown) {
        return `${this.forgetCountdown}s 后重试`;
      }
      return "获取验证码";
    },
    // getCodeBtnText() {
    //   if (this.isCountingDown) {
    //     return `${this.countdown}s 后重试`;
    //   }
    //   return "获取验证码";
    // },
    phoneCodeBtnText() {
      // 修改判断条件为 phoneIsCountdown
      if (this.phoneIsCountdown) {
        return `${this.phoneCountingDown}s 后重试`;
      }
      return "获取验证码";
    },
    // getRegisterCodeBtnText() {
    //   if (this.isRegisterCountingDown) {
    //     return `${this.registerCountdown}s 后重试`;
    //   }
    //   return "获取验证码";
    // },
    // getFpCodeBtnText() {
    //   if (this.isFpCountingDown) {
    //     return `${this.fpCountdown}s 后重试`;
    //   }
    //   return "获取验证码";
    // },
  },
  data() {
    return {
      activeTitleIndex: 0,
      contentItems: ["账号登录内容", "微信登录内容"],
      // 登录倒计时相关状态
      isLoginCountingDown: false,
      loginCountdown: 60,
      // 忘记密码倒计时相关状态
      isForgetCountingDown: false,
      forgetCountdown: 60,
      phone: "",
      password: "",
      isCodeLogin: false,
      // isCountingDown: false,
      phoneIsCountdown: false,
      // countdown: 60,
      phoneCountingDown: 60,
      // phone_codeError: "",
      forget_codeError: "",
      forget_code: "",
      phoneError: "",
      forget_phone: "",
      forget_phoneError: "",
      codeError: "",
      forget_passwordError: "",
      forget_password: "",
      enroll_username: "",
      enroll_usernameError: "",
      enroll_codeError: "",
      enroll_idNumberError: "",
      enroll_code: "",
      enroll_password: "",
      enroll_passwordError: "",
      enroll_confirmPassword: "",
      enroll_confirmPasswordError: "",
      enroll_nickname: "",
      enroll_nicknameError: "",
      enroll_phone: "",
      enroll_phoneError: "",
      enroll_email: "",
      enroll_emailError: "",
      enroll_idTypeError: "",
      enroll_genderError: "",
      // isRegisterCountingDown: false,
      forget_confirmPassword: "",
      forget_confirmPasswordError: "",
      // registerCountdown: 60,
      forget_passwordError: "",
      code: "",
      loginTimer: null, // 登录验证码定时器
      forgetTimer: null, // 忘记密码验证码定时器
      registerTimer: null, // 注册验证码定时器
      // gender: [
      //   {
      //     value: 1,
      //     label: "男",
      //   },
      //   {
      //     value: 2,
      //     label: "女",
      //   },
      // ],
      // options: [
      //   {
      //     value: 1,
      //     label: "身份证",
      //   },
      // ],
      // value: "",
      // value1: "",
      // // 新增状态变量，控制当前显示的内容
      // isFpCountingDown: false,
      // fpCountdown: 60,
    };
  },
  mounted() {
    // if (this.activeTitleIndex === 1) {
    //   this.initWechatLogin();
    // }
  },
  methods: {
    // handleChange() {
    //   // 处理证件类型选择变化
    // },
    // handleChange1() {
    //   // 处理性别选择变化
    // },
    close() {
      this.$emit("update:visible", false);
      this.forget_phone = "";
      this.forget_phoneError = "";
      this.forget_code = "";
      this.forget_codeError = "";
      this.forget_password = "";
      this.forget_passwordError = "";
      this.forget_confirmPassword = "";
      this.forget_confirmPasswordError = ""; // // 重置 isCodeLogin 状态
      this.isCodeLogin = false;
      // 清空验证码和密码输入框
      this.phone = "";
      this.phoneError = "";
      this.code = "";
      this.password = "";
      // 清空错误信息
      this.phoneError = "";
      this.codeError = "";
      this.enroll_username = "";
      this.enroll_password = "";
      this.enroll_confirmPassword = "";
      this.enroll_nickname = "";
      this.enroll_phone = "";
      this.enroll_code = "";
      this.enroll_codeError = "";
      this.enroll_idNumber = "";
      this.value = "";
      this.value1 = "";
    },
    switchTitle(index) {
      this.activeTitleIndex = index;
      if (index === 1) {
        this.initWechatLogin();
      }
    },
    initWechatLogin() {
      const script = document.createElement("script");
      script.src =
        "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
      script.onload = () => {
        this.initWxLogin();
      };
      script.onerror = () => {
        console.error("微信登录脚本加载失败");
      };
      document.body.appendChild(script);
    },
    initWxLogin() {
      const wxLogin = new WxLogin({
        self_redirect: true,
        id: "wechat_qrcode",
        appid: "gh_69557d25af50",
        scope: "snsapi_login",
        redirect_uri: "YOUR_REDIRECT_URI",
        state: "YOUR_STATE",
        style: "black",
        href: "",
      });
    },
    switchLoginType() {
      this.isCodeLogin = !this.isCodeLogin;
      if (this.isCodeLogin) {
        this.password = "";
      } else {
        this.code = "";
      }
    },
    validatePhone(phone) {
      const reg = /^1[3-9]\d{9}$/;
      return reg.test(phone);
    },

    // 登录获取验证码
    getLoginCode() {
      const phone = this.phone;
      if (!this.validatePhone(phone)) {
        this.phoneError = "请输入正确的手机号";
        return;
      }
      this.phoneError = "";
      this.startLoginCountdown();
    },
    // 登录获取验证码倒计时
    startLoginCountdown() {
      console.log("登录获取验证码倒计时");
      this.isLoginCountingDown = true;
      this.loginCountdown = 60;
      // 先清除可能存在的定时器，避免多个定时器同时运行
      if (this.loginTimer) {
        clearInterval(this.loginTimer);
      }
      const loginTimer = setInterval(() => {
        this.loginCountdown--;
        if (this.loginCountdown < 0) {
          clearInterval(this.loginTimer);
          this.loginTimer = null; // 清除引用
          this.isLoginCountingDown = false;
          this.loginCountdown = 60;
        }
      }, 1000);
    },

    // 忘记密码获取验证码
    async getForgetPasswordCode() {
      const phone = this.forget_phone;
      if (!this.validatePhone(phone)) {
        this.forget_phoneError = "请输入正确的手机号";
        return;
      }
      this.forget_phoneError = "";
      const res = await method.send_code(phone, 2);
      console.log(res);
      this.loadingMessage = this.$message({
        showClose: true,
        iconClass: "el-icon-loading",
        message: "正在发送...",
        duration: 0,
      });
      if (res.code == 1) {
        this.startForgetPasswordCountdown();
        this.loadingMessage.close();
        this.$message({
          showClose: true,
          type: "success",
          message: "发送成功请注意查收",
        });
      } else {
        this.loadingMessage.close();
        this.$message({
          showClose: true,
          type: "error",
          message: res.msg || "发送失败，请稍后重试",
        });
      }
    },
    // 忘记密码获取验证码倒计时
    startForgetPasswordCountdown() {
      console.log("忘记密码获取验证码倒计时");
      this.isForgetCountingDown = true;
      this.forgetCountdown = 60;
      // 先清除可能存在的定时器
      if (this.forgetTimer) {
        clearInterval(this.forgetTimer);
      }
      const forgetTimer = setInterval(() => {
        this.forgetCountdown--;
        if (this.forgetCountdown < 0) {
          clearInterval(forgetTimer);
          this.forgetTimer = null; // 清除引用
          this.isForgetCountingDown = false;
          this.forgetCountdown = 60;
        }
      }, 1000);
    },
    // 注册获取验证码倒计时
    async phoneCountdown() {
      const phone = this.enroll_phone;
      if (!this.validatePhone(phone)) {
        this.enroll_phoneError = "请输入正确的手机号";
        return;
      }
      const res = await method.send_code(phone, 1);
      console.log(res);
      this.loadingMessage = this.$message({
        showClose: true,
        iconClass: "el-icon-loading",
        message: "正在发送...",
        duration: 0,
      });
      if (res.code == 1) {
        this.startForgetCountdown();
        this.loadingMessage.close();
        this.$message({
          showClose: true,
          type: "success",
          message: "发送成功请注意查收",
        });
      } else {
        this.loadingMessage.close();
        this.$message({
          showClose: true,
          type: "error",
          message: res.msg,
        });
      }
    },
    startForgetCountdown() {
      console.log("注册获取验证码倒计时");
      this.enroll_phoneError = "";
      this.phoneIsCountdown = true;
      this.phoneCountingDown = 60;
      // 先清除可能存在的定时器
      if (this.registerTimer) {
        clearInterval(this.registerTimer);
      }
      const registerTimer = setInterval(() => {
        this.phoneCountingDown--;
        if (this.phoneCountingDown < 0) {
          clearInterval(registerTimer);
          this.registerTimer = null; // 清除引用
          this.phoneIsCountdown = false;
          this.phoneCountingDown = 60;
        }
      }, 1000);
    },
    // 登录提交
    login() {
      const phone = this.phone;
      const code = this.code;
      const password = this.password;
      this.phoneError = "";
      if (this.isCodeLogin) {
        if (!phone) {
          this.phoneError = "请输入账号";
          Message.error(this.phoneError);
          return;
        }
        if (!code) {
          this.codeError = "请输入验证码";
          Message.error(this.codeError);
          return;
        }
        this.codeError = "";
        Message.success(`使用验证码登录，手机号：${phone}，验证码：${code}`);
      } else {
        if (!phone) {
          this.phoneError = "请输入账号";
          Message.error(this.phoneError);
          return;
        }
        if (!password) {
          this.codeError = "请输入密码";
          Message.error(this.codeError);
          return;
        }
        // 验证密码长度
        if (password.length < 6 || password.length > 30) {
          this.codeError = "密码长度需在 6 - 30 个字符之间";
          Message.error(this.codeError);
          return;
        }
        this.phoneError = "";
        this.codeError = "";
        this.login_in();
      }
    },
    async login_in() {
      const res = await method.login(this.phone, this.password);
      if (res.code == 1) {
        Message.success("登录成功");
        localStorage.setItem("token", res.data.userinfo.token);
        localStorage.setItem("username", res.data.userinfo.username);
        localStorage.setItem("avatar", res.data.userinfo.avatar);
        localStorage.setItem("user_id", res.data.userinfo.user_id);
        this.$store.dispatch("updateNuser_in", true);
        this.close();
        this.switchToLogin();
        this.$router.push({
          path: "/user/PersonalCenter",
        });
      } else {
        if (res.msg) {
          Message.error(res.msg);
        } else {
          Message.error("登录失败!请关闭弹窗后重试！");
        }
      }
    },
    // 切换到注册
    switchToRegister() {
      this.$emit("customEvent", "register");
      this.$emit("newTitle", "手机号注册");
      // this.enroll_username = "";
      // this.enroll_password = "";
      // this.enroll_confirmPassword = "";
      // this.enroll_nickname = "";
      // this.enroll_phone = "";
      // this.enroll_code = "";
      // this.enroll_codeError = "";
      // this.enroll_idNumber = "";
      // this.value = "";
      // this.value1 = "";
    },
    // 切换到登录
    switchToLogin() {
      this.$emit("customEvent", "login");
      this.$emit("newTitle", "登录/注册");
      // // 重置 isCodeLogin 状态
      // this.isCodeLogin = false;
      // // 清空验证码和密码输入框
      // this.phone = "";
      // this.phoneError = "";
      // this.code = "";
      // this.password = "";
      // // 清空错误信息
      // this.phoneError = "";
      // this.codeError = "";
    },
    // 切换到忘记密码
    switchToForgetPassword() {
      this.$emit("customEvent", "forgetPassword");
      this.$emit("newTitle", "忘记密码");
      // this.forget_phone = "";
      // this.forget_phoneError = "";
      // this.forget_code = "";
      // this.forget_codeError = "";
      // this.forget_password = "";
      // this.forget_passwordError = "";
      // this.forget_confirmPassword = "";
      // this.forget_confirmPasswordError = "";
    },
    // 注册提交
    async register() {
      if (!this.enroll_username) {
        this.enroll_usernameError = "请输入用户名";
        return;
      } else {
        this.enroll_usernameError = "";
      }
      if (!this.enroll_phone) {
        this.enroll_phoneError = "请输入手机号";
        return;
      } else {
        this.enroll_phoneError = "";
      }
      if (!this.validatePhone(this.enroll_phone)) {
        this.enroll_phoneError = "请输入正确的手机号";
        return;
      } else {
        this.enroll_phoneError = "";
      }
      if (!this.enroll_code) {
        this.enroll_codeError = "请输入验证码";
        return;
      } else {
        this.enroll_codeError = "";
      }
      if (!this.enroll_password) {
        this.enroll_passwordError = "请输入密码";
        return;
      }
      // 检查密码长度是否在 6 - 30 个字符之间
      if (this.enroll_password.length < 6 || this.enroll_password.length > 30) {
        this.enroll_passwordError = "密码长度需在 6 - 30 个字符之间";
        return;
      } else {
        this.enroll_passwordError = "";
      }
      if (this.enroll_password !== this.enroll_confirmPassword) {
        this.enroll_confirmPasswordError = "两次输入的密码不一致";
        return;
      } else {
        this.enroll_confirmPasswordError = "";
      }
      // if (!this.enroll_nickname) {
      //   this.enroll_nicknameError = "请输入姓名";
      //   return;
      // } else {
      //   this.enroll_nicknameError = "";
      // }

      // if (!this.enroll_email) {
      //   this.enroll_emailError = "请输入电子邮件";
      //   return;
      // } else {
      //   this.enroll_emailError = "";
      // }
      // if (!this.value) {
      //   this.enroll_idTypeError = "请选择证件类型";
      //   return;
      // } else {
      //   this.enroll_idTypeError = "";
      // }
      // if (!this.enroll_idNumber) {
      //   this.enroll_idNumberError = "请输入证件号";
      //   return;
      // } else {
      //   this.enroll_idNumberError = "";
      // }
      // if (!this.value1) {
      //   this.enroll_genderError = "请选择性别";
      //   return;
      // } else {
      //   this.enroll_genderError = "";
      // }
      const res = await method.register(
        this.enroll_username,
        this.enroll_confirmPassword,
        this.enroll_phone,
        this.enroll_code
        // this.enroll_email,
        // this.value,
        // this.enroll_idNumber,
        // this.value1,
        // this.enroll_nickname,
      );
      if (res.code === 1) {
        Message.success("注册成功!请登录");
        this.switchToLogin();
      } else {
        if (res.msg) {
          Message.error(res.msg);
        } else {
          Message.error("注册失败!请关闭弹窗后重试！");
        }
      }
    },
    // 忘记密码提交
    async submitForgetPassword() {
      const phone = this.forget_phone;
      const code = this.forget_code;
      const password = this.forget_password;
      const confirmPassword = this.forget_confirmPassword;

      if (!this.validatePhone(phone)) {
        this.forget_phoneError = "请输入正确的手机号";
        return;
      }
      this.forget_phoneError = "";

      if (!code) {
        this.forget_codeError = "请输入验证码";
        return;
      }
      this.forget_codeError = "";

      if (!password) {
        this.forget_passwordError = "请输入新密码";
        return;
      }
      this.forget_passwordError = "";

      if (password !== confirmPassword) {
        this.forget_confirmPasswordError = "两次输入的密码不一致";
        return;
      }
      this.forget_confirmPasswordError = "";

      const res = await method.resetpwd(phone, password, confirmPassword, code);
      if (res.code === 1) {
        Message.success("密码重置成功");
        this.switchToLogin();
      } else {
        if (res.msg) {
          Message.error(res.msg);
        } else {
          Message.error("密码重置失败!请关闭弹窗后重试！");
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/pc/login_in.scss";
@import "@/assets/css/pc/register.scss";
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.title {
  position: relative;
}
.title span:hover {
  background-color: #0f3f77;
}
.title .active {
  background-color: #0f3f77;
  color: #fff;
}
.title span {
  float: left;
  width: 428px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  justify-content: center;
  background-color: #0f3f77;
  color: #fff;
}
.close-icon {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 17px;
  right: 20px;
  transform-origin: center; //
  transition: transform 1s ease; // 添加过渡效果
}
.close-icon:hover {
  transform: rotate(360deg) scale(1.5);
}
</style>
